/* ============
 * Mutations for the Units module
 * ============
 *
 * The mutations that are available on the
 * Units module.
 */

import {
  ADD_FAVOURITE,
  LOAD,
  LOAD_RELATED,
  REMOVE_FAVOURITE,
  SET_CROP,
  SET_CURRENT,
  SET_FAVOURITES,
} from './mutation-types';

/* eslint-disable no-param-reassign */
export default {
  [LOAD](state, units) {
    state.units = units.data;
  },
  [SET_CURRENT](state, unit) {
    state.currentUnit = unit;
  },
  [LOAD_RELATED](state, relatedData) {
    state.units.find(unit => unit.unit_id === relatedData.unit).related = relatedData.related;
  },
  [ADD_FAVOURITE](state, { order, unit }) {
    state.favourites.push(unit);
  },
  [REMOVE_FAVOURITE](state, { order, unit }) {
    state.favourites.splice(state.favourites.findIndex(fav => unit.unit_id === fav.unit_id), 1);
  },
  [SET_FAVOURITES](state, units) {
    state.favourites = Array.from(units);
  },
  [SET_CROP](state, crop) {
    state.crop = crop;
  },
};
